import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17969 18354"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M15767 11397h-4824c-315 0-525 315-420 594l1398 3601L1608 9649l10313-5943-1398 3600c-105 280 105 595 419 595h4825v3496zm874 419V7446c0-244-210-454-455-454h-4614l1608-4160c70-175 35-385-140-490-140-105-350-140-489-35L524 9264c-279 175-279 594 0 769l12027 6957c69 35 139 70 209 70 315 0 525-349 385-629l-1608-4125h4614c280-35 490-245 490-490zM3321 17515c-594 0-1083-490-1083-1084 0-595 489-1084 1083-1084 595 0 1084 489 1084 1084 0 559-489 1084-1084 1084zm0-3077c-1083 0-1957 874-1957 1958s874 1958 1957 1958c1084 0 1958-874 1958-1958s-874-1958-1958-1958zM5279 1328c489 0 874 385 874 874 0 490-385 874-874 874s-874-384-874-874c0-489 385-874 874-874zm0 2622c979 0 1748-769 1748-1748S6258 455 5279 455s-1748 768-1748 1747 769 1748 1748 1748zM16641 4405c-245 0-455-210-455-455 0-244 210-454 455-454 244 0 454 210 454 454 0 245-210 455-454 455zm0-1748c-734 0-1329 594-1329 1328 0 735 595 1329 1329 1329s1328-594 1328-1329c0-734-629-1328-1328-1328zM1224 1573c251 0 454 204 454 455 0 250-203 454-454 454s-455-203-455-454 204-455 455-455zM455 12655c251 0 454 203 454 455 0 251-203 454-454 454S0 13361 0 13110c0-252 204-455 455-455zM8320 16606c252 0 455 203 455 454s-203 455-455 455c-250 0-454-204-454-455s204-454 454-454zM16641 15277c250 0 454 204 454 455s-204 454-454 454c-251 0-455-203-455-454s204-455 455-455zM14893 0c251 0 454 204 454 455 0 250-203 454-454 454s-455-204-455-454c1-251 204-455 455-455z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
